import React from 'react'
import { motion, AnimatePresence } from "framer-motion"
import { Pullstate } from '../components/pullstate'
import { useEase } from '../components/motion'
import { TransitionCover } from '../components/transition'
import { useChapterData } from "../hooks/chapter_data"

export const StickyFooterNav = ( props ) => {

   const coverLoaded = Pullstate.useState( s => s.isCoverLoaded )
	const navInView = Pullstate.useState( s => s.isChapterNavInView )
	const isDesktop = props.breakpoint != 'mobile'

   const stickyVar = {
		open: {
			bottom: 0,
			transition: {
				delay: 0.3,
			},
		},
		closed: {
			bottom: -60,
		},
   }

	const momentVar = {
		open: {
			top: isDesktop ? 20 : 'auto',
			transition: {
				delay: 0.6,
			}
		},
		closed: {
			top: isDesktop ? -50 : 'auto'
		}
	}

   const screenVar = {
		initial: {
         scaleX: 1,
      },
      start : {
         bottom: 0,
      },
		exit: {
			bottom: -60,
			transition: {
				ease: useEase("easeOutQuart"),
				duration: 0.75,
				delay: 0.5,
			},
		},
	}

	const theme = props.theme ? props.theme : 'default'
	const currentTheme = props.currentMomentTheme ? props.currentMomentTheme : 'default'
	const classes = `stickyFooterNav theme-${theme}`
	const currentClasses = `currentMoment theme-${currentTheme}`

	const currentNum = props.index
	const currentMoment = ("0" + currentNum).slice(-2)

   const prev = "chapter" + (currentNum - 1)
   const next = "chapter" + (currentNum + 1)

   const chapterData = useChapterData()

   let prevTitle,
		prevSlug,
		prevNum,
		nextTitle,
      nextSlug,
      nextNum

   if (currentNum > 1) {
		prevTitle = props.prevTitle
			? props.prevTitle
			: chapterData[prev].chapter_title
		prevSlug = chapterData[prev].UID
      let number = chapterData[prev].chapter_number
      prevNum = `${( '0' + number ).slice(-2)}.`
   }
   if (currentNum < 20) {
		nextTitle = props.nextTitle
			? props.nextTitle
			: chapterData[next].chapter_title
		nextSlug = chapterData[next].UID
      let number = chapterData[next].chapter_number
      nextNum = `${( '0' + number ).slice(-2)}.`
   } else {
		nextTitle = 'Start Over'
		nextSlug = chapterData.chapter1.UID
		let number= chapterData.chapter1.chapter_number
		nextNum = `${( '0' + number ).slice(-2)}.`
	}

   return (
		<motion.nav
			className={classes}
			variants={stickyVar}
			initial="open"
			animate={navInView || props.menuOpen ? "closed" : "open"}
		>
			<AnimatePresence initial={false}>
				{!coverLoaded && (
					<motion.div
						className="stickyFooterScreen"
						variants={screenVar}
						initial="initial"
						animate="start"
						exit="exit"
					></motion.div>
				)}
			</AnimatePresence>
			<TransitionCover
				cover
				to={`/${prevSlug}`}
				direction="up"
				duration={1.8}
				bg="#ff0000"
				className="stickyNav-prev stickyNavLink"
			>
				<div className="prev-arrow stickyNavArrow">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 77.2 6.01"
					>
						<g id="thinArrowLeft">
							<path d="M0,3,5.47,6V0Z" fill="currentColor" />
							<path
								d="M4,3.16H77.2"
								fill="none"
								stroke="currentColor"
							/>
						</g>
					</svg>
				</div>
				<div className="prev-number stickyNavNumber">{prevNum}</div>
				<div className="prev-title stickyNavTitle">{prevTitle}</div>
				<div className="prev-hover stickyNavHover"></div>
			</TransitionCover>

			<motion.div className={currentClasses} variants={momentVar} >{currentMoment}</motion.div>

			<TransitionCover
				cover
				to={`/${nextSlug}`}
				direction="up"
				duration={1.8}
				bg="#ff0000"
				className="stickyNav-next stickyNavLink"
			>
				<div className="next-number stickyNavNumber">{nextNum}</div>
				<div className="next-title stickyNavTitle">{nextTitle}</div>
				<div className="next-arrow stickyNavArrow">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 77.2 6.01"
					>
						<g id="thinArrowRight">
							<path d="M77.2,3,71.73,6V0Z" fill="currentColor" />
							<path
								d="M73.25,3.16H0"
								fill="none"
								stroke="currentColor"
							/>
						</g>
					</svg>
				</div>
				<div className="next-hover stickyNavHover"></div>
			</TransitionCover>
		</motion.nav>
   )
}